<template>
  <div>
    <!-- 顶部导航栏 - 仅桌面端显示 -->
    <header id="navbar" class="hidden lg:block fixed w-full top-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16 md:h-20">
        <!-- Logo -->
        <div class="flex items-center flex-shrink-0">
          <router-link to="/" class="flex items-center">
            <div class="w-10 h-10 rounded-lg bg-primary flex items-center justify-center flex-shrink-0">
              <i class="fas fa-graduation-cap text-white text-xl"></i>
            </div>
            <span class="ml-2 sm:ml-3 text-base sm:text-lg md:text-xl font-bold text-primary whitespace-nowrap">良知技能人才平台</span>
          </router-link>
        </div>
        
        <!-- 桌面导航 -->
        <nav class="hidden lg:flex space-x-6 xl:space-x-8">
          <router-link to="/" exact class="text-gray-dark hover:text-primary transition-custom font-medium">首页</router-link>
          <router-link to="/courses" exact class="text-gray-dark hover:text-primary transition-custom font-medium">考证课程</router-link>
          <router-link to="/quizzes" exact class="text-gray-dark hover:text-primary transition-custom font-medium">练习题集</router-link>
          <router-link to="/exams" exact class="text-gray-dark hover:text-primary transition-custom font-medium">证书考试</router-link>
          <router-link to="/certificate" exact class="text-gray-dark hover:text-primary transition-custom font-medium">证书鉴别</router-link>
          <a href="https://www.rongyuezhiya.com/" target="_blank" rel="noopener noreferrer" class="text-gray-dark hover:text-primary transition-custom font-medium">就业指导</a>
        </nav>
        
        <!-- 桌面端用户操作 -->
        <div class="hidden lg:flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
          <!-- 未登录时显示登录注册按钮 -->
          <template v-if="!isLoggedIn">
            <button @click="openLoginModal" class="px-3 xl:px-4 py-2 text-primary border border-primary rounded-lg hover:bg-primary/5 transition-custom text-sm xl:text-base">
              登录
            </button>
            <button @click="openRegisterModal" class="px-3 xl:px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-custom shadow-sm text-sm xl:text-base">
              注册
            </button>
          </template>
          
          <!-- 用户菜单（登录后显示） -->
          <div v-if="isLoggedIn" class="flex items-center space-x-3 xl:space-x-4">
            <router-link to="/profile" class="flex items-center space-x-2 hover:opacity-80 transition-custom">
              <img :src="userAvatar" alt="用户头像" class="w-8 h-8 rounded-full object-cover border-2 border-primary">
              <span class="text-sm font-medium">{{ userName }}</span>
            </router-link>
            <button @click="logout" class="px-3 py-1 text-sm text-danger hover:bg-red-50 rounded-lg transition-custom">
              退出
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 退出登录确认框 -->
    <ConfirmModal
      :show.sync="showLogoutConfirm"
      title="退出登录"
      message="确定要退出登录吗？"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="confirmLogout"
    />
  </header>

  <!-- 移动端底部Tabbar - 仅在指定页面显示 -->
  <nav v-if="showTabbar" class="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg safe-area-bottom">
    <div class="flex justify-around items-center h-16">
      <!-- 首页 -->
      <router-link to="/" exact class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-home text-lg"></i>
          <span class="text-xs">首页</span>
        </div>
      </router-link>
      
      <!-- 培训考证 -->
      <router-link to="/courses" exact class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-graduation-cap text-lg"></i>
          <span class="text-xs">课程</span>
        </div>
      </router-link>
      
      <!-- 题库练习 -->
      <router-link to="/quizzes" exact class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-book text-lg"></i>
          <span class="text-xs">练习</span>
        </div>
      </router-link>
      
      <!-- 证书鉴别 -->
      <router-link to="/certificate" exact class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-certificate text-lg"></i>
          <span class="text-xs">鉴别</span>
        </div>
      </router-link>
      
      <!-- 就业创业 -->
      <a href="https://www.rongyuezhiya.com/" target="_blank" rel="noopener noreferrer" class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-briefcase text-lg"></i>
          <span class="text-xs">就业</span>
        </div>
      </a>
      
      <!-- 我的 -->
      <router-link v-if="isLoggedIn" to="/profile" exact class="tabbar-item">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-user text-lg"></i>
          <span class="text-xs">我的</span>
        </div>
      </router-link>
      
      <div v-else class="tabbar-item relative" @click="handleMineClick">
        <div class="flex flex-col items-center justify-center gap-0.5">
          <i class="fas fa-user text-lg"></i>
          <span class="text-xs">我的</span>
        </div>
      </div>
    </div>
  </nav>
  </div>
</template>

<script>
import ConfirmModal from './ConfirmModal.vue'

export default {
  name: 'Header',
  components: {
    ConfirmModal
  },
  data() {
    return {
      showLogoutConfirm: false
    }
  },
  computed: {
    // 从store获取登录状态
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    // 从store获取用户信息
    user() {
      return this.$store.getters.getUser
    },
    // 从store获取用户名
    userName() {
      return this.$store.getters.getUserName
    },
    // 从store获取用户头像
    userAvatar() {
      return this.$store.getters.getUserAvatar
    },
    // 根据路由元信息判断是否显示Tabbar
    showTabbar() {
      // 从路由meta中获取showTabbar配置，默认为false
      return this.$route.meta.showTabbar || false
    }
  },
  mounted() {
    // 导航栏滚动效果
    window.addEventListener('scroll', this.handleScroll)
    // 初始化用户状态
    this.$store.dispatch('initUserState')
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const navbar = document.getElementById('navbar')
      if (window.scrollY > 50) {
        navbar.classList.add('shadow-md')
        navbar.classList.remove('shadow-sm')
      } else {
        navbar.classList.remove('shadow-md')
        navbar.classList.add('shadow-sm')
      }
    },
    // 处理"我的"tab点击（未登录时）
    handleMineClick() {
      // 未登录，显示登录弹框
      this.openLoginModal()
    },
    openLoginModal() {
      this.$emit('open-login-modal')
    },
    openRegisterModal() {
      this.$emit('open-register-modal')
    },
    // 退出登录
    logout() {
      // 显示确认弹框
      this.showLogoutConfirm = true
    },
    // 确认退出登录
    confirmLogout() {
      this.$store.dispatch('logout')
      this.showLogoutConfirm = false
      // 显示退出成功提示
      this.$message.success('退出登录成功')
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.router-link-active {
  color: var(--color-primary) !important;
  font-weight: 600;
}

// 底部Tabbar样式
.tabbar-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 0.375rem 0.25rem;
  min-width: 0; // 允许项目收缩
  position: relative;
  
  &:active {
    transform: scale(0.95);
  }
  
  &.router-link-active {
    color: var(--color-primary) !important;
    background: linear-gradient(to bottom, rgba(79, 70, 229, 0.08), transparent);
    
    // 顶部指示条
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 60%;
      height: 3px;
      background: var(--color-primary);
      border-radius: 0 0 3px 3px;
    }
    
    i {
      color: var(--color-primary);
      transform: scale(1.1);
      font-weight: 600;
    }
    
    span {
      font-weight: 700;
      color: var(--color-primary);
    }
  }
  
  &:hover {
    color: var(--color-primary);
    opacity: 0.8;
  }
  
  // 确保文字不会换行
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.3s ease;
  }
  
  // 图标样式
  i {
    transition: all 0.3s ease;
  }
  
  // 小屏幕优化
  @media (max-width: 375px) {
    padding: 0.375rem 0.125rem;
    
    span {
      font-size: 0.625rem; // 10px
    }
    
    i {
      font-size: 1rem !important; // 16px
    }
  }
}

// 安全区域适配（适配有虚拟Home键的设备）
.safe-area-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}
</style> 
